import { render, staticRenderFns } from "./ShowCommentModal2.vue?vue&type=template&id=61747470&scoped=true&"
import script from "./ShowCommentModal2.vue?vue&type=script&lang=js&"
export * from "./ShowCommentModal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61747470",
  null
  
)

export default component.exports